// For showing datadog info in the console
export const showElogsBrandedConsoleInfo = ( message: string ) => {
	console.info( `%c${message}`, 'background-color: #134b5f; color: #e9f5f9;' )
}
